import * as React from 'react'
import { cn } from '@/lib/utils'
import { IconProps, StudyIcon } from '@/components/svg/study-icon'
import { StudentAssignedIcon } from '@/components/svg/student-assigned-icon'
import { PracticeTestIcon } from '@/components/svg/practice-test-icon'
import { QuestionLibraryIcon } from '@/components/svg/question-library-icon'
import { MockTestIcon } from '@/components/svg/mock-test-icon'

interface ModulesSidebarProps {
	active?: string
	onChange?: (key: string) => void
	className?: string
	items?: Array<{ key: string; label: string; icon: React.ComponentType<IconProps> }>
	iconSize?: number
}

const defaultItems: ModulesSidebarProps['items'] = [
	{ key: 'study-text', label: 'Study Text', icon: StudyIcon },
	{ key: 'question-library', label: 'Question Library', icon: QuestionLibraryIcon },
	{ key: 'mock-test', label: 'Mock Tests', icon: MockTestIcon },
	{ key: 'practice-test', label: 'Practice Tests', icon: PracticeTestIcon },
	{ key: 'student-assigned', label: 'Students', icon: StudentAssignedIcon },
]

export const ModulesSidebar: React.FC<ModulesSidebarProps> = ({
	active,
	onChange,
	className,
	items = defaultItems!,
	iconSize = 20,
}) => {
	return (
		<nav
			className={cn(
				'w-64 shrink-0 rounded-lg border border-[#E4E7EC] bg-white/80 backdrop-blur-sm flex flex-col gap-1',
				className
			)}
		>
			<ul className='flex flex-col gap-1'>
				{items.map((it) => {
					const Icon = it.icon
					const isActive = active === it.key
					return (
						<li key={it.key}>
							<button
								type='button'
								onClick={() => onChange?.(it.key)}
								className={cn(
									'group flex w-full items-center gap-3 px-3 py-2 text-sm font-medium transition-colors border-l-[3px] border-transparent',
									'focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0057B8]/30',
									isActive
										? 'bg-[#0057B8]/10 text-[#0057B8] border-l-[#B42318]'
										: 'text-[#475467] hover:bg-[#F2F4F7] hover:text-[#003A80]'
								)}
							>
								<Icon
									size={iconSize}
									className={cn(
										'flex-shrink-0',
										isActive ? 'text-[#0057B8]' : 'text-[#667085] group-hover:text-[#003A80]'
									)}
								/>
								<span className='truncate'>{it.label}</span>
							</button>
						</li>
					)
				})}
			</ul>
		</nav>
	)
}

export default ModulesSidebar

